module.exports = __webpack_public_path__ + "img/banner2.bf93494c.png";